module.exports = __webpack_public_path__ + "static/media/DJLuvaLuva-Thumb.9dcf49c6.png";